import { Component, OnInit, Input } from '@angular/core';
import { BeneficiaryType } from '@app/enums/BeneficiaryType';
import { AlertService } from '@app/services/alert.service';
import { BeneficiaryService } from '@app/services/admin/beneficiary.service';

@Component({
  selector: 'app-beneficiary-logs-update-segment',
  templateUrl: './beneficiary-logs-update-segment.component.html',
  styleUrls: ['./beneficiary-logs-update-segment.component.scss']
})
export class BeneficiaryLogsUpdateSegmentComponent implements OnInit {
  private static readonly EMPTY = '( Empty )';
  _data;
  isOpen = false;
  @Input() public data: any;
  beneficiaryName : any;
  beneficiaryType : BeneficiaryType;
  constructor(private beneficiaryService: BeneficiaryService,
    private alertService: AlertService) { }

  ngOnInit() {
    this.beneficiaryType = this.data.Table =="InvestorAssetManagerLookup" ? BeneficiaryType.AssetManager : 
                           this.data.Table == "InvestorFundLookup" ? BeneficiaryType.Fund :
                           this.data.Table == "InvestorBeneficiary"? BeneficiaryType.DecisionMaker : BeneficiaryType.AssetManager;
    this.beneficiaryService.getBeneficiary(this.data.PrimaryKey.Id, this.beneficiaryType)
                            .subscribe(b=> { this.beneficiaryName = b.name},
                            err => {
                              this.alertService.sendError(err.error);
                            });
    const values = this.data.ColumnValues;
    this._data = Object.keys(values).map(key => {
      return {
        new: values[key] ? values[key] : 'Empty',
      };
    });
  }

}
